/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { ContainerTemplate } from '../models/container-template';
import { ContainerTemplateCopyTemplateToPageContainerDto } from '../models/container-template-copy-template-to-page-container-dto';
import { ContainerTemplateCopyToPageContainerDto } from '../models/container-template-copy-to-page-container-dto';
import { ContainerTemplateCreateDto } from '../models/container-template-create-dto';
import { ContainerTemplateWithRelations } from '../models/container-template-with-relations';

@Injectable({
  providedIn: 'root',
})
export class ContainerTemplateControllerService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation containerTemplateControllerCopyTemplateToPageContainer
   */
  static readonly ContainerTemplateControllerCopyTemplateToPageContainerPath = '/container-templates/copy-template-to-page-container';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `copyTemplateToPageContainer()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  copyTemplateToPageContainer$Response(params?: {
    body?: ContainerTemplateCopyTemplateToPageContainerDto
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, ContainerTemplateControllerService.ContainerTemplateControllerCopyTemplateToPageContainerPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `copyTemplateToPageContainer$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  copyTemplateToPageContainer(params?: {
    body?: ContainerTemplateCopyTemplateToPageContainerDto
  }): Observable<any> {

    return this.copyTemplateToPageContainer$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation containerTemplateControllerCopyToPageContainer
   */
  static readonly ContainerTemplateControllerCopyToPageContainerPath = '/container-templates/copy-to-page-container';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `copyToPageContainer()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  copyToPageContainer$Response(params?: {
    body?: ContainerTemplateCopyToPageContainerDto
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, ContainerTemplateControllerService.ContainerTemplateControllerCopyToPageContainerPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `copyToPageContainer$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  copyToPageContainer(params?: {
    body?: ContainerTemplateCopyToPageContainerDto
  }): Observable<any> {

    return this.copyToPageContainer$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation containerTemplateControllerFindById
   */
  static readonly ContainerTemplateControllerFindByIdPath = '/container-templates/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findById()` instead.
   *
   * This method doesn't expect any request body.
   */
  findById$Response(params: {
    id: string;
    filter?: any;
  }): Observable<StrictHttpResponse<ContainerTemplateWithRelations>> {

    const rb = new RequestBuilder(this.rootUrl, ContainerTemplateControllerService.ContainerTemplateControllerFindByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
      rb.query('filter', params.filter, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ContainerTemplateWithRelations>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findById(params: {
    id: string;
    filter?: any;
  }): Observable<ContainerTemplateWithRelations> {

    return this.findById$Response(params).pipe(
      map((r: StrictHttpResponse<ContainerTemplateWithRelations>) => r.body as ContainerTemplateWithRelations)
    );
  }

  /**
   * Path part for operation containerTemplateControllerDeleteById
   */
  static readonly ContainerTemplateControllerDeleteByIdPath = '/container-templates/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteById()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteById$Response(params: {
    id: string;
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, ContainerTemplateControllerService.ContainerTemplateControllerDeleteByIdPath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `deleteById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteById(params: {
    id: string;
  }): Observable<any> {

    return this.deleteById$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation containerTemplateControllerFind
   */
  static readonly ContainerTemplateControllerFindPath = '/container-templates';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `find()` instead.
   *
   * This method doesn't expect any request body.
   */
  find$Response(params?: {
    filter?: any;
  }): Observable<StrictHttpResponse<Array<ContainerTemplateWithRelations>>> {

    const rb = new RequestBuilder(this.rootUrl, ContainerTemplateControllerService.ContainerTemplateControllerFindPath, 'get');
    if (params) {
      rb.query('filter', params.filter, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<ContainerTemplateWithRelations>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `find$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  find(params?: {
    filter?: any;
  }): Observable<Array<ContainerTemplateWithRelations>> {

    return this.find$Response(params).pipe(
      map((r: StrictHttpResponse<Array<ContainerTemplateWithRelations>>) => r.body as Array<ContainerTemplateWithRelations>)
    );
  }

  /**
   * Path part for operation containerTemplateControllerCreate
   */
  static readonly ContainerTemplateControllerCreatePath = '/container-templates';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `create()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  create$Response(params?: {
    body?: ContainerTemplateCreateDto
  }): Observable<StrictHttpResponse<ContainerTemplate>> {

    const rb = new RequestBuilder(this.rootUrl, ContainerTemplateControllerService.ContainerTemplateControllerCreatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ContainerTemplate>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `create$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  create(params?: {
    body?: ContainerTemplateCreateDto
  }): Observable<ContainerTemplate> {

    return this.create$Response(params).pipe(
      map((r: StrictHttpResponse<ContainerTemplate>) => r.body as ContainerTemplate)
    );
  }

}
